export default __webpack_public_path__ + "static/media/teamwork-lower.fbdd1d4c.png";